import { Component, OnInit } from '@angular/core';
import { NavParams, AlertController, ModalController } from '@ionic/angular';
import { STORAGE } from 'src/app/constant/storages';
import { ApiserviceService } from 'src/app/httpservice/apiservice.service';
import { errMsg } from 'src/app/text_control/error-msg';
import { _getStorage } from 'src/app/utils/local-storage';

@Component({
  selector: 'app-modal-save-draft-no-taxinvoice',
  templateUrl: './modal-save-draft-no-taxinvoice.component.html',
  styleUrls: ['./modal-save-draft-no-taxinvoice.component.scss'],
})
export class ModalSaveDraftNoTaxinvoiceComponent implements OnInit {
  userBu: string = "";
  userLoc: string = "";
  userRole: string = "";
  userID: string = "";
  userSource: string = "";

  tpno = true;
  company_name: any;
  buyer_id: any;
  email: string = "";
  receiptNo: string = "";
  is_email: boolean = false;
  is_print: boolean = true;
  transaction_no: string = "";
  seller_name: string = "";
  generate_date: string = "";

  constructor(
    public navParams: NavParams,
    public apiservice: ApiserviceService,
    public alertController: AlertController,
    public modalCtrl: ModalController
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.company_name = navParams.get("company_name");
    this.buyer_id = navParams.get("buyer_id");
  }

  ngOnInit() {}

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
  cancelDraft(){
    this.modalCtrl.dismiss({ dismissed: true });
  }
  saveDraft() {
    if (this.company_name === "") {
      return this.ErrorMsg("กรุณากรอก ชื่อ - นามสกุล / ชื่อบริษัท");
    }
    if (this.email !== "") {
      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.email)) return this.ErrorMsg(errMsg.errorEmail);
    }
    // if (this.tpno === "") {
    //   return this.ErrorMsg("กรุณาเลือก ใบเสร็จ");
    // }
    if (this.receiptNo === "") {
      return this.ErrorMsg("กรุณากรอกเลข ใบเสร็จ");
    }
    if (this.is_email === false && this.is_print === false) {
      return this.ErrorMsg(
        "กรุณาเลือก ส่งใบเสร็จชั่วคราวไปยัง Email หรือ ปริ้นเอกสาร"
      );
    }
    if (this.is_email === true) {
      if (this.email === "") {
        return this.ErrorMsg("กรุณากรอก Email");
      }
    }
    

    const req = {
      storeLoc: this.userLoc,
      storeBu: this.userBu,
      userId: this.userID,
      userSource: this.userSource,
      receiptNo: this.receiptNo,
      isTpNo: this.tpno,
      email: this.email || "",
      buyerId: this.buyer_id,
    };

    console.log('req=====:: ',req)
    this.apiservice
      ._post(this.apiservice.apiUrl + this.apiservice.draftTransaction, req)
      .then((res) => {
        console.log("RES POST SAVE DRAFT",res);
        if (res.statusCode === 200) {
          this.transaction_no = res.data.draft_transaction_no
          this.seller_name = res.data.seller_name;
          this.generate_date = res.data.generate_date;
          console.log('this.transaction_no=====:: ',this.transaction_no)
          setTimeout(() => {
            
            this.printInvoice();
            this.modalCtrl.dismiss({ dismissed: true });
          }, 500);
        } else {
        }
      });
  }

  printInvoice() {
    let printContents, popupWin;

    printContents = document.getElementById("print").innerHTML.toString();
    printContents = (<string>printContents + "").replace("col-sm", "col-xs");
    // console.log(printContents);
    popupWin = window.open("", "_blank", "top=0,left=0,height=100%,width=auto");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>ออกใบรับ</title>
          <meta name="viewport" content="width=10, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
          integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous">
          <style>
           
          </style>
        </head>
        <body onload="window.print();">
        ${printContents}
        </body>
      </html>`);
    setTimeout(() => {
      popupWin.close();
    }, 1000);
    popupWin.document.close();
  }

}
